module.exports = __webpack_public_path__ + "static/media/trainer4.bab461ec.jpg";